import { SearchOutlined } from '@ant-design/icons';
import { Col, DatePicker, Input, Row, Space, TreeSelect, Tooltip } from 'antd';
import ClearFilter from 'components/Global/ClearFilter';
// import ExportData from 'components/Global/ExportData';
import PayPeriodFilter from 'components/Global/PayPeriodFilter';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import { useEffect, useState, useRef, useCallback, useMemo } from 'react';
import { getOptionLabel } from 'utils/utils';

interface Props {
	handlePayPeriod: (payPeriodId: string) => void;
	selectedPayPeriod: string | null;
	performFilterHandler: (key: string, value: any) => void;
	performSearchHandler: (value: string) => void;
	searchValue: string;
	filterValue: any;
	clearFilter: () => void;
	yearHandler: (year: any) => void;
	yearValue: any;
}

const SearchAndFilter = (props: Props) => {
	const {
		selectedPayPeriod,
		handlePayPeriod,
		clearFilter,
		performFilterHandler,
		performSearchHandler,
		filterValue,
		searchValue,
		yearHandler,
		yearValue,
	} = props;

	// const { timeSummaryData } = useSelector((state: any) => state.reports);
	const { optionData: customer } = useSelector((state: any) => state.customer);

	// Local state for immediate UI updates
	const [localCustomerIds, setLocalCustomerIds] = useState<string[]>(
		(filterValue?.customerId as string[]) || []
	);
	const [customersTooltipDisabled, setCustomersTooltipDisabled] = useState(false);

	// Debounce ref for customer filter
	const customerDebounceRef = useRef<NodeJS.Timeout | null>(null);

	// Sync local state with filterValue when it changes externally (e.g., clear filter)
	useEffect(() => {
		setLocalCustomerIds((filterValue?.customerId as string[]) || []);
	}, [filterValue?.customerId]);

	// Debounced handler for customer filter
	const debouncedSetCustomers = useCallback(
		(customerIds: string[]) => {
			setLocalCustomerIds(customerIds);
			if (customerDebounceRef.current) {
				clearTimeout(customerDebounceRef.current);
			}
			customerDebounceRef.current = setTimeout(() => {
				performFilterHandler('customerId', customerIds);
			}, 500);
		},
		[performFilterHandler]
	);

	// Cleanup timeout on unmount
	useEffect(() => {
		return () => {
			if (customerDebounceRef.current) {
				clearTimeout(customerDebounceRef.current);
			}
		};
	}, []);

	// Filter customer data to remove "Select Customer" option
	const filteredCustomerData = useMemo(() => {
		if (!Array.isArray(customer)) {
			return [];
		}
		return customer.filter((item: any) => {
			return item?.title !== 'Select Customer';
		});
	}, [customer]);

	return (
		<div className={styles['search-filter']}>
			<div className={`${styles['search-filter__wrapper']}`}>
				{/* <Row justify="space-between">
					<Col>
						<Space>
							<PayPeriodFilter
								payPeriodId={selectedPayPeriod}
								onChangePayPeriodId={(value) => {
									handlePayPeriod(value);
								}}
							/>
							<Input
								className={styles['search-filter__tree-filter']}
								placeholder="Search here..."
								style={{ fontSize: '12px', minHeight: '40px' }}
								suffix={<SearchOutlined />}
								onChange={(e) => {
									performSearchHandler(e.target.value);
								}}
								value={searchValue}
								size="large"
							/>
							<TreeSelect
								className={styles['search-filter__tree-filter']}
								dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
								size="large"
								placeholder="Customer"
								value={filterValue?.customerId}
								showSearch
								onChange={(value) => performFilterHandler('customerId', value)}
								treeData={customer}
								treeDefaultExpandAll
								filterTreeNode={(inputValue, treeNode) => {
									return treeNode.props.title
										.toLowerCase()
										.includes(inputValue.toLowerCase());
								}}
							/>
							<Col span={4}>
								<Space>
									<DatePicker
										className={styles['search-filter__search']}
										size="large"
										picker="year"
										onChange={yearHandler}
										value={yearValue}
										clearIcon={false}
									/>
								</Space>
							</Col>
							<div className={styles['scaled-clear-filter']}>
								<ClearFilter clearFilter={clearFilter} />
							</div>{' '}
						</Space>
					</Col> */}
				{/* {timeSummaryData?.timeActivitySummary &&
						timeSummaryData?.timeActivitySummary.length > 0 && (
							<Col>
								<Space className="search-filter-export">
									<ExportData
										moduleName="timeSummaryReport"
										params={{
											payPeriodId: selectedPayPeriod,
											filterValue,
											searchValue,
										}}
									/>
								</Space>
							</Col>
						)} */}
				{/* </Row> */}

				<Row
					className={styles['custom-row']}
					align="middle"
					justify="space-between"
				>
					<Col>
						<Space wrap >
							<PayPeriodFilter
								payPeriodId={selectedPayPeriod}
								onChangePayPeriodId={(value) => handlePayPeriod(value)}
							/>

							<Input
								placeholder="Search here..."
								style={{ fontSize: '12px', minWidth: 200, height: 40 }}
								suffix={<SearchOutlined />}
								onChange={(e) => performSearchHandler(e.target.value)}
								value={searchValue}
								size="large"
							/>

							<TreeSelect
								placeholder="Customers"
								value={localCustomerIds}
								onChange={debouncedSetCustomers}
								size="large"
								allowClear
								multiple
								maxTagCount={0}
								treeDefaultExpandAll
								showSearch
								treeData={filteredCustomerData}
								style={{ minWidth: 200, fontSize: '12px', height: 40 }}
								filterTreeNode={(inputValue, treeNode) =>
									treeNode?.props?.title
										?.toLowerCase()
										.includes(inputValue.toLowerCase())
								}
								treeLine
								onDropdownVisibleChange={(open) => {
									setCustomersTooltipDisabled(open);
								}}
								maxTagPlaceholder={() => {
									const selectedCustomerIds = localCustomerIds;
									if (selectedCustomerIds.length === 0) return 'Customers';
									const customerLabels = selectedCustomerIds.map((id: string) => {
										return getOptionLabel(id, filteredCustomerData) || id;
									});
									return (
										<Tooltip
											title={
												<div className="filter-tooltip-content">
													{customerLabels.map((label: string, i: number) => (
														<div
															key={i}
															className="filter-tooltip-item"
															style={{
																borderBottom:
																	i !== customerLabels.length - 1
																		? '1px solid rgba(52, 71, 53, 0.1)'
																		: 'none',
															}}
														>
															{label}
														</div>
													))}
												</div>
											}
											placement="bottom"
											overlayClassName="filter-tooltip"
											visible={customersTooltipDisabled ? false : undefined}
											trigger={customersTooltipDisabled ? [] : ['hover']}
										>
											Customers ({selectedCustomerIds.length})
										</Tooltip>
									);
								}}
							/>

							<DatePicker
								picker="year"
								size="large"
								onChange={yearHandler}
								value={yearValue}
								className={styles['search-filter__search']}
								style={{ minWidth: 140, height: 40 }}
								clearIcon={false}
							/>

							<div className={styles['scaled-clear-filter']}>
								<ClearFilter clearFilter={clearFilter} />
							</div>
						</Space>
					</Col>

					<Col
						span={4}
						className={styles['custom-col']}
						style={{ textAlign: 'right' }}
					>
						{/* {timeSummaryData?.timeActivitySummary?.length > 0 && (
							<ExportData
								moduleName="timeSummaryReport"
								params={{
									payPeriodId: selectedPayPeriod,
									filterValue,
									searchValue,
								}}
							/>
						)} */}
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default SearchAndFilter;
